/* RL Landing hero — sticky CTA on scroll.
   Vanilla, no module. Prefixed globals only.

   The button pins to the bottom of the viewport once the whole hero
   section has scrolled off the top, and releases when the hero comes
   back into view. Observing the section — not the button — means the
   trigger tracks the hero's real height, so it feels right on both the
   tall mobile stack and the shorter desktop layout with no tuning.

   The original button stays in the flow; the class toggles it to
   position:fixed, so there is no clone to keep in sync — clicks, href
   and the modal wiring all keep working on the one element. */
(function () {
  'use strict';

  var RL_HERO_STICKY_ACTIVE = 'is-sticky-active';

  function RL_HERO_STICKY_start(actions) {
    var cta = actions.querySelector('[data-rl-hero-cta]');
    if (!cta) return;
    if (actions.hasAttribute('data-rl-hero-sticky-wired')) return;

    /* Observe the hero section, so the button pins only once the whole
       hero has passed. Fall back to the actions wrapper if the section
       class is ever renamed, so the sticky still works. */
    var hero = actions.closest('.rl-landing-hero') || actions;
    actions.setAttribute('data-rl-hero-sticky-wired', '');

    var stuck = false;

    var observer = new IntersectionObserver(
      function (entries) {
        var entry = entries[0];
        /* Stick once the hero has scrolled off the TOP, not when it is
           merely below the fold on first load — hence the top < 0 guard. */
        var next = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
        if (next === stuck) return;
        stuck = next;

        /* Reserve the button's row before it leaves the flow, so the price
           note below it — and the rest of the hero — does not jump up.
           Measured live: the button height plus the wrapper's row gap, which
           is exactly the space the note must stay clear of. Measured each
           time because it varies with the viewport. */
        if (stuck) {
          var rowGap = parseFloat(getComputedStyle(actions).rowGap) || 0;
          var reserved = cta.getBoundingClientRect().height + rowGap;
          actions.style.setProperty(
            '--rl-landing-hero-actions-reserved',
            reserved + 'px'
          );
        }

        cta.classList.toggle(RL_HERO_STICKY_ACTIVE, stuck);
      },
      { threshold: 0 }
    );

    observer.observe(hero);
  }

  function RL_HERO_STICKY_init() {
    var groups = document.querySelectorAll('[data-rl-hero-sticky]');
    for (var i = 0; i < groups.length; i++) RL_HERO_STICKY_start(groups[i]);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', RL_HERO_STICKY_init);
  } else {
    RL_HERO_STICKY_init();
  }

  document.addEventListener('shopify:section:load', RL_HERO_STICKY_init);
})();
